import { Link } from "react-router-dom";
import type { NewsArticle } from "@/mocks/news";
import { formatDate, getCategoryById } from "@/utils/news";

interface Props {
  article: NewsArticle;
}

export default function ArticleGridCard({ article }: Props) {
  const category = getCategoryById(article.categoryId);

  return (
    <Link
      to={`/detail/${article.id}`}
      className="group flex flex-col bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 黑料吃瓜网`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 px-2 py-1 rounded bg-primary-900/85 text-background-50 text-[11px] tracking-wide">
          {category?.name ?? "资讯"}
        </span>
      </div>
      <div className="flex-1 flex flex-col p-3.5 md:p-4">
        <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {article.title}
        </h3>
        <p className="mt-2 text-xs md:text-[13px] leading-relaxed text-foreground-600 line-clamp-2">
          {article.summary}
        </p>
        <div className="mt-3 pt-3 border-t border-background-200 flex items-center justify-between text-[11px] text-foreground-500">
          <span>{article.author}</span>
          <span>{formatDate(article.publishedAt)}</span>
        </div>
      </div>
    </Link>
  );
}